export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-03.jpg'),
        title: 'アプリケーション・アウトソーシング',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: `レガシーアプリケーションのコア技術`,
      description: `<p style="font-size:1.05rem">
      MaesInfoのソフトウェア開発サービスは、アプリケーション開発およびカスタム製品開発を含みます。当社の開発者は最新技術と、クライアントのレガシーアプリの中核技術に精通しています。MaesInfoではソフトウェアコンポーネントを活用してアプリケーションを構築し、コストと開発期間を削減します。これに当社の強力な管理・コミュニケーションプロセスが組み合わさり、優れたアウトソーシングパートナーとしてお客様の目的達成を支援します。
      </p><p>サービス範囲：Webアプリ開発、モバイルアプリ開発、デスクトップアプリ開発、組込みソフトウェア開発、リレーショナルDB運用、AJAXアプリケーション、業務プロセス自動化アプリケーション</p>`
    },
    {
      title: '当社の強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-03.jpg')+`)"></span>
      <span class="list">
        <i></i>課題と解決策を明確に定義します</br>
        <i></i>費用と納期が明確です</br>
        <i></i>最新のシステム・技術・プロセスに関する専門知識があります</br>
        <i></i>追加コストを発生させません</br>
        <i></i>開発拠点の柔軟性を提供します</br>
        <i></i>お客様はコア業務により多くの時間を割けます
      </span>`
    }
  ]
}
